import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Collapse, Group, Stack, Text, ThemeIcon, Paper, Divider } from "@mantine/core";
import { IconBox, IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import cx from "clsx";

import { ListAssetDto } from "../../models/assets.models";
import assetListClasses from "../Assets/AssetList.module.css";

interface VendorAssetsListProps {
	assets?: ListAssetDto[] | null;
}

export const VendorAssetsList = ({ assets }: VendorAssetsListProps) => {
	const [isOpen, setIsOpen] = useState(false);

	if (!assets || assets.length === 0) {
		return null;
	}

	return (
		<Stack gap={0} mb="lg">
			<Divider mb="md" />
			<Group
				justify="space-between"
				py="sm"
				onClick={() => setIsOpen(!isOpen)}
				style={{ cursor: "pointer", marginBottom: isOpen ? "md" : 0 }}
			>
				<Group gap={8}>
					<Text fz="xs" fw="700" tt="uppercase" c="dimmed">
						Assets ({assets.length})
					</Text>
				</Group>
				{isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
			</Group>

			<Collapse in={isOpen}>
				<Paper p={0} radius="md" style={{ overflow: "hidden" }}>
					<Stack gap={0}>
						{assets.map((asset) => (
							<Button
								key={asset.AssetId}
								component={Link}
								to={`/assets/${asset.AssetId}`}
								className={cx(assetListClasses["asset-list-item"])}
								w="100%"
								leftSection={
									<ThemeIcon radius="xl" color="blue" size="xl" style={{ border: "1px solid var(--mantine-color-default-border)" }} variant="light">
										<IconBox size={24} />
									</ThemeIcon>
								}
							>
								<Stack gap={2} align="flex-start">
									<Text fw={500}>{asset.Name}</Text>
									{(asset.AssetType || asset.Location?.Title) && (
										<Text fz="xs" c="dimmed">
											{asset.AssetType || ""}{asset.AssetType && asset.Location?.Title ? " - " : ""}{asset.Location?.Title || ""}
										</Text>
									)}
								</Stack>
							</Button>
						))}
					</Stack>
				</Paper>
			</Collapse>
		</Stack>
	);
};
